export default "__VITE_ASSET__Pf_st9Ta__"